import React from 'react'

interface Props {
  className: string
}

const Hr = ({ className }: Props) => {
  return <hr className={className} />
}

export default Hr
